import React from 'react';

const cx = (...c) => c.filter(Boolean).join(' ');

const TONES = {
  brand: 'bg-brand-50 text-brand-700 ring-1 ring-brand-100',
  accent: 'bg-accent-50 text-accent-700 ring-1 ring-accent-200',
  neutral: 'bg-ink-100 text-ink-600 ring-1 ring-ink-200',
  success: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100',
  warning: 'bg-amber-50 text-amber-700 ring-1 ring-amber-100',
  danger: 'bg-red-50 text-red-700 ring-1 ring-red-100',
};

// Small status / category pill. Pass `color` for an arbitrary hex (district
// brand colors); otherwise use a semantic `tone`.
const Badge = ({ tone = 'neutral', color, className, children }) => {
  if (color) {
    return (
      <span
        className={cx(
          'inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded-full text-white',
          className
        )}
        style={{ backgroundColor: color }}
      >
        {children}
      </span>
    );
  }
  return (
    <span
      className={cx(
        'inline-flex items-center text-xs font-semibold px-2.5 py-1 rounded-full',
        TONES[tone] || TONES.neutral,
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
